{
  "name": "@geoman-io/leaflet-geoman-free",
  "version": "2.19.3",
  "description": "A Leaflet Plugin For Editing Geometry Layers in Leaflet 1.0",
  "keywords": [
    "leaflet",
    "geoman",
    "polygon management",
    "geometry editing",
    "map data",
    "map overlay",
    "polygon",
    "geojson",
    "leaflet-draw",
    "data-field-geojson",
    "ui-leaflet-draw"
  ],
  "files": [
    "dist/leaflet-geoman.js",
    "dist/leaflet-geoman.min.js",
    "dist/leaflet-geoman.css",
    "dist/leaflet-geoman.d.ts",
    "dist/leaflet-geoman.js.map",
    "dist/leaflet-geoman.css.map"
  ],
  "main": "dist/leaflet-geoman.js",
  "module": "dist/leaflet-geoman.js",
  "types": "dist/leaflet-geoman.d.ts",
  "exports": {
    ".": {
      "types": "./dist/leaflet-geoman.d.ts",
      "import": "./dist/leaflet-geoman.js",
      "require": "./dist/leaflet-geoman.js",
      "default": "./dist/leaflet-geoman.js"
    },
    "./dist/leaflet-geoman.css": "./dist/leaflet-geoman.css"
  },
  "dependencies": {
    "@turf/boolean-contains": "^7.3.3",
    "@turf/kinks": "^7.3.3",
    "@turf/line-intersect": "^7.3.3",
    "@turf/line-split": "^7.3.3",
    "lodash": "4.18.1",
    "polyclip-ts": "^0.16.8"
  },
  "devDependencies": {
    "@types/leaflet": "^1.9.21",
    "@vitest/coverage-v8": "^4.0.18",
    "cross-env": "^10.1.0",
    "cypress": "^15.9.0",
    "esbuild": "^0.27.2",
    "oxlint": "^1.0.0",
    "oxfmt": "^0.32.0",
    "husky": "^9.1.7",
    "leaflet": "1.9.4",
    "lint-staged": "^16.2.7",
    "prosthetic-hand": "1.4.0",
    "typescript": "^5.9.3",
    "vitest": "^4.0.18"
  },
  "peerDependencies": {
    "leaflet": "^1.2.0"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "scripts": {
    "start": "npm run dev",
    "dev": "cross-env DEV=true node bundle.mjs",
    "build": "node bundle.mjs",
    "test": "cypress run --browser chrome",
    "test:unit": "vitest run",
    "test:unit:watch": "vitest",
    "test:unit:coverage": "vitest run --coverage",
    "test:all": "npm run test:unit && npm run test",
    "cypress": "cypress open",
    "prepare": "npm run build && husky",
    "lint": "oxlint src demo --fix && oxfmt --write src demo",
    "lint:check": "oxlint src demo && oxfmt --check src demo",
    "typecheck": "tsc --noEmit"
  },
  "repository": {
    "type": "git",
    "url": "git://github.com/geoman-io/leaflet-geoman.git"
  },
  "author": {
    "name": "Geoman.io",
    "email": "sales@geoman.io",
    "url": "http://geoman.io"
  },
  "license": "MIT",
  "bugs": {
    "url": "https://github.com/geoman-io/leaflet-geoman/issues"
  },
  "homepage": "https://geoman.io",
  "lint-staged": {
    "*.js": "oxlint --fix",
    "*.{js,css}": "oxfmt --write"
  }
}
